// --------------------------------------------------------
// REQUEST APPOINTMENT MODAL - RequestAppointmentModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Checkbox, Modal } from "@mui/material";
import React, { useCallback, useState } from "react";
import { ReactComponent as Medic } from "../../../../assets/imgs/medicIcon.svg";
import { OverflowAwareContainer } from "../../../../components/appointmentAttendance/EncaixeModal";
import CareLineDropdown from "../../../../components/dropdown/CareLineDropdown";
import { ModalContentContainer } from "../../../../components/genericModal/GenericModal.styled";
import { GenericSolidButton } from "../../../../components/UI/buttons/Button.styled";
import {
  H1,
  Text,
} from "../../../../components/UI/generalLayout/Layout.styled";
import Colors from "../../../../constants/Colors";
import { meses } from "../../../../constants/Objects";
import useResponsiveInfo from "../../../../hooks/useResponsiveInfo";
import Category from "../../../../models/core/careLine/Category";
import {
  getYearAfterToday,
  getYearBeforeToday,
} from "../../../../utils/date.utils";
import { Subtitle } from "../attendanceRecord/components/details/DetailsAttendanceRecord.styled";
import { CancelButton } from "./AttachCareLine";
import { AppointmentService } from "../../../../core/http/service/AppointmentService";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// REQUEST APPOINTMENT MODAL INTERFACE
// --------------------------------------------------------

export interface IAprazamento {
  linhaCuidadoCategoriaId: String;
  pacienteId: String;
  data: String;
}

interface IRequestAppointmentModal {
  idPaciente: String;
  visible: boolean;
  categorias: Category[];
  onCancelar: () => void;
  refreshCategoria: () => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const RequestAppointmentModal = ({
  idPaciente,
  visible,
  categorias,
  onCancelar,
  refreshCategoria,
}: IRequestAppointmentModal) => {
  // --------------------------------------------------------
  // REQUEST APPOINTMENT MODAL PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const service = new AppointmentService();

  const { isMobile } = useResponsiveInfo();
  // const [healthProfessionalType, setHealthProfessionalsType] = useState<any[]>();
  const [selectedYear, setSelectedYear] = useState<any>({ id: "", nome: "" });

  const [selectedMonth, setSelectedMonth] = useState<any>({ id: "", nome: "" });

  const [idCategoria, setIdCategoria] = useState<String>("");

  const years = getYearAfterToday(5);

  const yearsLabels = years.map<any>(value => ({
    nome: value,
    id: value,
  }));

  const months = meses.map<any>((value: string, index: number) => ({
    nome: value,
    id: String(index + 1),
  }));

  const newAplazamento = async () => {
    const mes =
      parseInt(selectedMonth.id) < 10
        ? "0" + selectedMonth.id
        : selectedMonth.id;
    const dataAprazamento = `${selectedYear.nome}-${mes}-01`;

    const response = await service.addNewAprazamento({
      linhaCuidadoCategoriaId: idCategoria,
      pacienteId: idPaciente,
      data: dataAprazamento,
    });

    if (response.status === 200) {
      refreshCategoria();
    }
  };

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <Modal open={visible}>
        <OverflowAwareContainer
          isMobile={isMobile}
          style={{ backgroundColor: "white", height: "550px" }}
        >
          <ModalContentContainer isMobile={isMobile}>
            <div style={{ textAlign: "center" }}>
              <H1>Solicitar Consulta</H1>
              <Subtitle>
                Preencha a data prevista para a próxima consulta e qual o tipo
                de profissional
              </Subtitle>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                marginLeft: 15,
              }}
            >
              <div
                style={{
                  width: isMobile ? "100%" : "60%",
                  marginTop: isMobile ? 30 : 10,
                }}
              >
                <div style={{ display: "flex", flexDirection: "row", gap: 12 }}>
                  <Medic />
                  <Text bold>Consulta médica</Text>
                </div>
                <div>
                  <Text bold>Data prevista</Text>
                  <div
                    style={{ flexDirection: "row", display: "flex", gap: 10 }}
                  >
                    <CareLineDropdown
                      containerStyle={{ width: "50%" }}
                      value={selectedMonth}
                      onChange={setSelectedMonth}
                      items={months}
                      disabled={false}
                    />
                    <CareLineDropdown
                      containerStyle={{ width: "50%" }}
                      value={selectedYear}
                      onChange={setSelectedYear}
                      items={yearsLabels}
                      disabled={false}
                    />
                  </div>
                </div>
                <div>
                  <Text bold>Tipo de profissional</Text>
                  {categorias.map((c: any) => {
                    return (
                      <div
                        style={{
                          flexDirection: "row",
                          display: "flex",
                          gap: 10,
                        }}
                      >
                        <Checkbox
                          checked={idCategoria === c.id}
                          onChange={() => {
                            setIdCategoria(c.id);
                          }}
                        />
                        <Text>{c.nome}</Text>
                      </div>
                    );
                  })}
                </div>
              </div>
              {!isMobile && (
                <div
                  style={{
                    gap: 10,
                    flexDirection: "row",
                    display: "flex",
                    marginTop: 20,
                  }}
                >
                  <CancelButton
                    style={{ width: 150 }}
                    onClick={() => {
                      onCancelar();
                    }}
                  >
                    Cancelar
                  </CancelButton>
                  <GenericSolidButton
                    color={Colors.SPM600}
                    onClick={() => {
                      newAplazamento();
                    }}
                  >
                    Salvar solicitação
                  </GenericSolidButton>
                </div>
              )}
            </div>
            {isMobile && (
              <div
                style={{
                  gap: 10,
                  flexDirection: isMobile ? "column" : "row",
                  display: "flex",
                  marginTop: 20,
                  marginLeft: 10,
                }}
              >
                <CancelButton
                  style={{ width: isMobile ? "100%" : 150 }}
                  onClick={() => {
                    onCancelar();
                  }}
                >
                  Cancelar
                </CancelButton>
                <GenericSolidButton
                  color={Colors.SPM600}
                  onClick={() => {
                    newAplazamento();
                  }}
                >
                  Salvar solicitação
                </GenericSolidButton>
              </div>
            )}
          </ModalContentContainer>
        </OverflowAwareContainer>
      </Modal>
    </>
  );
  // --------------------------------------------------------
};

export default RequestAppointmentModal;
